import React from "react";
import "./textField.css";

export const TextField = ({ className = "", ...rest }) => {
   return <input className={`kv-field ${className}`} type="text" {...rest} />;
};
